import React from "react";
import MainSectionView from "src/pages/section/MainSection/view";

export interface MainSectionProps {
}

function MainSection(props: MainSectionProps) {
    return <MainSectionView {...props} />
}

export default MainSection;